import React from 'react';
import { Route, Routes } from 'react-router-dom';

import loadable from '@common/react/loadable/loadableSettings';

import Layout from '@app/components/Layouts/Layout';
import LayoutCut from '@app/components/Layouts/LayoutCut';
import LayoutFamilyResources from '@app/components/Layouts/LayoutFamilyResources';
import LayoutShort from '@app/components/Layouts/LayoutShort';
import LayoutWrapper from '@app/components/Layouts/LayoutWrapper';
import PhoneProvider from '@app/components/UI/PhoneProvider/PhoneProvider';

const Home = loadable(() => import(/* webpackChunkName: "HomePage" */ '@app/components/Pages/Home/Home'));
const VeterinaryHospice = loadable(() => import(/* webpackChunkName: "VeterinaryHospicePage" */ '@app/components/Pages/Services/VeterinaryHospice/VeterinaryHospice'));
const Euthanasia = loadable(() => import(/* webpackChunkName: "EuthanasiaPage" */ '@app/components/Pages/Services/Euthanasia/Euthanasia'));
const Aftercare = loadable(() => import(/* webpackChunkName: "AftercarePage" */ '@app/components/Pages/Services/Aftercare/Aftercare'));
const Burial = loadable(() => import(/* webpackChunkName: "BurialPage" */ '@app/components/Pages/Services/Aftercare/Burial/Burial'));
const Aquamation = loadable(() => import(/* webpackChunkName: "AquamationPage" */ '@app/components/Pages/Services/Aftercare/Aquamation/Aquamation'));
const Teleadvice = loadable(() => import(/* webpackChunkName: "TeleadvicePage" */ '@app/components/Pages/Services/Teleadvice/Teleadvice'));
const PetLossSupportGroup = loadable(() => import(/* webpackChunkName: "PetLossSupportGroupPage" */ '@app/components/Pages/Services/PetLossSupportGroup/PetLossSupportGroup'));
const AngelFund = loadable(() => import(/* webpackChunkName: "AngelFundPage" */ '@app/components/Pages/AngelFund/AngelFund'));
const Newsletter = loadable(() => import(/* webpackChunkName: "NewsletterPage" */ '@app/components/Pages/Newsletter/Newsletter'));
const FindVet = loadable(() => import(/* webpackChunkName: "FindVetPage" */ '@app/components/Pages/FindVet/FindVet'));
const AreasList = loadable(() => import(/* webpackChunkName: "AreasListPage" */ '@app/components/Pages/AreasList/AreasList'));
const Area = loadable(() => import(/* webpackChunkName: "AreaPage" */ '@app/components/Pages/Area/Area'));
const PetMemorial = loadable(() => import(/* webpackChunkName: "PetMemorialPage" */ '@app/components/Pages/PetMemorial/PetMemorial'));
const Veterinarian = loadable(() => import(/* webpackChunkName: "VeterinarianPage" */ '@app/components/Pages/AboutUs/Careers/Veterinarian'));
const VetTestimonials = loadable(() => import(/* webpackChunkName: "VetTestimonialsPage" */ '@app/components/Pages/VetTestimonials/VetTestimonials'));
const AboutUs = loadable(() => import(/* webpackChunkName: "AboutUsPage" */ '@app/components/Pages/AboutUs/AboutUs'));
const StudentExternship = loadable(() => import(/* webpackChunkName: "StudentExternshipPage" */ '@app/components/Pages/AboutUs/StudentExternship'));
const NotFound = loadable(() => import(/* webpackChunkName: "NotFoundPage" */ '@app/components/Pages/NotFound/NotFound'));
const PetLossSupport = loadable(() => import(/* webpackChunkName: "PetLossSupportPage" */ '@app/components/Pages/PetLossSupport/PetLossSupport'));
const PetLossBeginningToHeal = loadable(() => import(/* webpackChunkName: "PetLossBeginningToHealPage" */ '@app/components/Pages/PetLossBeginningToHeal/PetLossBeginningToHeal'));
const PetLossChildrenGrief = loadable(() => import(/* webpackChunkName: "PetLossChildrenGriefPage" */ '@app/components/Pages/PetLossChildrenGrief/PetLossChildrenGrief'));
const SupportCenterTeam = loadable(() => import(/* webpackChunkName: "SupportCenterTeamPage" */ '@app/components/Pages/AboutUs/SupportCenterTeam/SupportCenterTeam'));
const HowWillIKnowItsTime = loadable(() => import(/* webpackChunkName: "HowWillIKnowItsTimePage" */ '@app/components/Pages/HowWillIKnowItsTime/HowWillIKnowItsTime'));
const Article = loadable(() => import(/* webpackChunkName: "ArticlePage" */ '@app/components/Pages/Article/Article'));
const News = loadable(() => import(/* webpackChunkName: "NewsPage" */ '@app/components/Pages/News/News'));
const QualityOfLifeAssessment = loadable(() => import(/* webpackChunkName: "QualityOfLifeAssessmentPage" */ '@app/components/Pages/QualityOfLife/QualityOfLifeAssessment'));
const QOLQuestionary = loadable(() => import(/* webpackChunkName: "QOLQuestionaryPage" */ '@app/components/Pages/QualityOfLife/QOLQuestionary'));
const QOLResults = loadable(() => import(/* webpackChunkName: "QOLResultsPage" */ '@app/components/Pages/QualityOfLife/QOLResults'));
const VetResourceCenter = loadable(() => import(/* webpackChunkName: "VetResourceCenterPage" */ '@app/components/Pages/Resources/VetResources/VetResourceCenter'));
const VetResourcesLogged = loadable(() => import(/* webpackChunkName: "VetResourcesLoggedPage" */ '@app/components/Pages/Resources/VetResources/VetResourcesLogged'));
const FamilyResources = loadable(() => import(/* webpackChunkName: "FamilyResourcesPage" */ '@app/components/Pages/Resources/FamilyResources/FamilyResources'));
const Covid19 = loadable(() => import(/* webpackChunkName: "Covid19Page" */ '@app/components/Pages/Covid19/Covid19'));
const QOLDifferentSpecies = loadable(() => import(/* webpackChunkName: "QOLDifferentSpeciesPage" */ '@app/components/Pages/QualityOfLife/QOLDifferentSpecies'));
const Policies = loadable(() => import(/* webpackChunkName: "PoliciesPage" */ '@app/components/Pages/Policies/Policies'));
const OnlineBooking = loadable(() => import(/* webpackChunkName: "OnlineBookingPage" */ '@app/components/Pages/Booking/Booking'));

export const baseRoutes = (
	<>
		<Route element={<PhoneProvider phone="(855) 933-5683" />}>
			<Route element={<LayoutWrapper />}>
				<Route element={<Layout withScrollTop={false} />}>
					<Route path="/veterinarian-testimonials/:id?" element={<VetTestimonials />} />
				</Route>
				<Route element={<Layout />}>
					<Route path="/" element={<Home />} />
					<Route path="/our-services/veterinary-hospice" element={<VeterinaryHospice />} />
					<Route path="/our-services/in-home-euthanasia" element={<Euthanasia />} />
					<Route path="/our-services/aftercare" element={<Aftercare />} />
					<Route path="/our-services/aftercare/burial" element={<Burial />} />
					<Route path="/our-services/aftercare/aquamation" element={<Aquamation />} />
					<Route path="/our-services/telehospice" element={<Teleadvice />} />
					<Route path="/our-services/pet-loss-support" element={<PetLossSupportGroup />} />
					<Route path="/angel-fund" element={<AngelFund />} />
					<Route path="/careers/become-a-veterinarian" element={<Veterinarian />} />
					<Route path="/about-us/who-we-are" element={<AboutUs />} />
					<Route path="/about-us/student-externship" element={<StudentExternship />} />
					<Route path="/newsletter" element={<Newsletter />} />
					<Route path="/pet-loss-support-resources" element={<PetLossSupport />} />
					<Route path="/pet-loss-support-resources/healing-process" element={<PetLossBeginningToHeal />} />
					<Route path="/pet-loss-support-resources/children-and-pet-grief-resources" element={<PetLossChildrenGrief />} />
					<Route path="/how-will-i-know-it-is-time" element={<HowWillIKnowItsTime />} />
				</Route>
				<Route element={<LayoutCut />}>
					<Route path="/find-a-vet" element={<FindVet />} />
					<Route path="/find-a-vet/search" element={<AreasList />} />
					<Route path="/about-us/support-center-team" element={<SupportCenterTeam />} />
					<Route path="/quality-of-life-assessment" element={<QualityOfLifeAssessment />} />
					<Route path="/quality-of-life-assessment/question/:id" element={<QOLQuestionary />} />
					<Route path="/quality-of-life-assessment/results/:id?" element={<QOLResults />} />
					<Route path="/veterinary-resource-center" element={<VetResourceCenter />} />
					<Route path="/covid19" element={<Covid19 />} />
					<Route path="/policies/:item" element={<Policies />} />
				</Route>
				<Route element={<PhoneProvider phone="(855) 327-2325" />}>
					<Route element={<LayoutCut />}>
						<Route element={<OnlineBooking />}>
							<Route path="/online-booking/:step?" />
						</Route>
					</Route>
				</Route>

				<Route element={<LayoutCut withScrollTop={false} />}>
					<Route path="/pet-memorial/:id?" element={<PetMemorial />} />
					<Route path="/find-a-vet/:area/:id/:tab" element={<Area />} />
					<Route path="/in-the-news/:id?" element={<News />} />
					<Route path="/veterinary-resources/:topic/logged" element={<VetResourcesLogged />} />
				</Route>

				<Route element={<LayoutFamilyResources />}>
					<Route element={<FamilyResources />}>
						<Route path="/faq" />
						<Route path="/blog" />
						<Route path="/videos" />
						<Route path="/resource-center/:topic/:resource" />
						<Route path="/resource-center/:topic" />
						<Route path="/resource-center" />
					</Route>
					<Route path="/blog/:topic/:id" element={<Article />} />
				</Route>

				<Route element={<LayoutFamilyResources withScrollTop={false} />}>
					<Route element={<FamilyResources />}>
						<Route path="/faq/:id?" />
						<Route path="/blog/:id?" />
					</Route>
				</Route>

				<Route element={<LayoutShort />}>
					<Route path="/quality-of-life-assessment/different-species" element={<QOLDifferentSpecies />} />
				</Route>
				<Route element={<LayoutCut />}>
					<Route path="*" element={<NotFound />} />
				</Route>
			</Route>
		</Route>
	</>
);

export const routes = (
	<Routes>
		{baseRoutes}
	</Routes>
);
